export default {
  state: {
    activeUser: null
  },
  getters: {
    activeUser: state => state.activeUser
  },
  mutations: {
    activeUserSet (state, newActiveUser) {
      state.activeUser = newActiveUser
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/storeActiveUser.js